module.exports = __webpack_public_path__ + "media/images/ESR-7e846fbbf31dd0d8c1cf6f40218acf05.png";